export enum enumReportFormat {
  html = 'html',
  pdf = 'chrome-pdf',
  xlsx = 'html-to-xlsx'
}


export namespace enumReportFormat {
  export function values() {
    return Object.keys(enumReportFormat).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
